module.exports = __webpack_public_path__ + "img/ab19db8501be60834b5a11fac0f9c2a6.svg";